// extracted by mini-css-extract-plugin
export default {"root":"PageBuilderDivider-module-root-2nN"};